<template>
    <div id="content">
      <form action="#">
        <div class="inner">
          <p class="paging">
            <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
          </p>

          <h1>Přidat poskytovatele reklam</h1>
        </div>

        <div class="responsiveTabs">
          <settings
              :entity="entity"
              :isEditable="$_createActionAllowed"
              @saveEntity="createEntity"
          />
        </div>
      </form>
    </div>
</template>

<script>
import Settings from "./detail/Settings";
import detailActions from "@/components/mixins/detail-actions"

export default {
    name: 'AdvertisingProviderNew',
    components: { Settings },
    mixins: [detailActions],
    data() {
        return {
            entityName: 'advertisingProvider',
            moduleName: 'advertisingProviders',
            detailPageRouteName: 'advertisingProviderDetail',
            updateFields: [
              'name',
              'code',
              'module_type',
              'authentication_data',
            ],
        }
    },
    created(AdvertisingProviderService) {
        this.entityService = AdvertisingProviderService
    },
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingProviders/AdvertisingProviderNew.vue